import type { TrackingService } from '@/features/tracking/TrackingService'
import type { WorkspaceMember } from '@/features/iam/members/WorkspaceMember'

export class NoOpTrackingService implements TrackingService {
  identify(member: WorkspaceMember) {
    console.debug('Identifying as', member)
  }

  reset() {
    console.debug('resetting member')
  }

  static create() {
    return new NoOpTrackingService()
  }
}
